var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6395 14.5454L15.368 17.3008M15.3611 9.69921L10.6395 12.4546M19.2311 8.65383C19.2311 9.80088 18.3012 10.7308 17.1541 10.7308C16.0071 10.7308 15.0772 9.80088 15.0772 8.65383C15.0772 7.50677 16.0071 6.5769 17.1541 6.5769C18.3012 6.5769 19.2311 7.50677 19.2311 8.65383ZM10.9234 13.5C10.9234 14.647 9.99351 15.5769 8.84645 15.5769C7.6994 15.5769 6.76953 14.647 6.76953 13.5C6.76953 12.3529 7.6994 11.4231 8.84645 11.4231C9.99351 11.4231 10.9234 12.3529 10.9234 13.5ZM19.2311 18.3461C19.2311 19.4932 18.3012 20.4231 17.1541 20.4231C16.0071 20.4231 15.0772 19.4932 15.0772 18.3461C15.0772 17.1991 16.0071 16.2692 17.1541 16.2692C18.3012 16.2692 19.2311 17.1991 19.2311 18.3461Z",
    stroke: "#1A2746",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 13.5,
    r: 12.4615,
    stroke: "#1A2746",
    strokeWidth: 2.07692
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonSocial);
export default __webpack_public_path__ + "static/media/button-social.097eca9c7fe433280f1c74187eec5e32.svg";
export { ForwardRef as ReactComponent };